export const getQaCookies = (cookie: string): string =>
  cookie
    ?.split('; ')
    .filter((value) => value.includes('testId'))
    .join('; ');
